import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const CreateProgramTemplateHeaderWrapper = styled.div`
  .header-collapse {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 26px;
    height: 20px;

    ${responsive.MOBILE`
      margin-bottom: 16px !important;
    `}
    svg {
      margin-left: 12px;
    }
  }
`;
